var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#25282D",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "m6.985 6.98 10.111 10.11m0-10.11L6.985 17.09"
}))));
export { SvgIconClose as ReactComponent };
export default __webpack_public_path__ + "img/icon-close.b0648fc7e5efa7acc77b26cfd06e1958.svg";